import { useSearchParams, useNavigate } from 'react-router-dom'
import { useInView } from '../hooks/useInView'
import { foodMenu, drinksMenu } from '../data/menu'

// Toggle to temporarily hide the menu behind a "coming soon" notice
// without touching the underlying menu data/rendering below.
// Flip back to false to bring the real menu back.
const MENU_COMING_SOON = true

const fmt = (n) => '€' + n.toFixed(2)

function MenuSection({ section }) {
  const [ref, inView] = useInView()

  return (
    <div className={`menu-section fade-up${inView ? ' visible' : ''}`} ref={ref}>
      {section.headerImage && (
        <div className="menu-section-banner">
          <img src={section.headerImage} alt="" loading="lazy" />
        </div>
      )}
      <div className="menu-section-header">
        <h2 className="menu-section-title">{section.category}</h2>
        {section.note && <p className="menu-section-note">{section.note}</p>}
      </div>

      {section.type === 'draught' && (
        <table className="beer-table">
          <thead>
            <tr><th>Beer</th><th>½ Pint</th><th>Pint</th></tr>
          </thead>
          <tbody>
            {section.items.map(item => (
              <tr key={item.name}>
                <td>{item.name}</td>
                <td>{fmt(item.halfPint)}</td>
                <td>{fmt(item.pint)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {section.type === 'grid' && (
        <div className="cocktail-grid">
          {section.items.map(item => (
            <div key={item.name} className="cocktail-item">
              {item.icon && <img className="cocktail-icon" src={item.icon} alt="" loading="lazy" />}
              <span className="cocktail-name">{item.name}</span>
              <span className="cocktail-price">{fmt(item.price)}</span>
            </div>
          ))}
        </div>
      )}

      {!section.type && (
        <div>
          {section.items.map(item => (
            <div key={item.name} className="menu-item">
              {item.image && (
                <div className="menu-item-thumb">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
              )}
              <div className="menu-item-left">
                <p className="menu-item-name">
                  {item.name}
                  {item.badge && <span className="menu-item-badge">{item.badge}</span>}
                </p>
                {item.desc && <p className="menu-item-desc">{item.desc}</p>}
              </div>
              {item.price != null && <span className="menu-item-price">{fmt(item.price)}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default function Menu() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab') === 'drinks' ? 'drinks' : 'food'
  const data = tab === 'food' ? foodMenu : drinksMenu

  return (
    <div className="menu-page">
      <div className="menu-page-hero">
        <h1 className="menu-page-title">GOAT</h1>
        <p className="menu-page-sub">Greatest of All Tapas · Paceville, Malta</p>
      </div>

      {MENU_COMING_SOON ? (
        <div className="menu-coming-soon">
          <p className="eyebrow eyebrow-dark">★&nbsp;&nbsp;Kitchen &amp; Bar&nbsp;&nbsp;★</p>
          <h2 className="menu-coming-soon-title">Our Menu Is Coming Soon</h2>
          <p className="menu-coming-soon-body">
            We're putting the finishing touches on our new menu. Check back soon, or follow us for updates.
          </p>
        </div>
      ) : (
        <>
          <div className="menu-tabs">
            <button
              className={`menu-tab${tab === 'food' ? ' active' : ''}`}
              onClick={() => setSearchParams({ tab: 'food' })}
            >
              Food Menu
            </button>
            <button
              className={`menu-tab${tab === 'drinks' ? ' active' : ''}`}
              onClick={() => setSearchParams({ tab: 'drinks' })}
            >
              Drinks Menu
            </button>
          </div>

          <div className="menu-content">
            {data.map(section => (
              <MenuSection key={section.id} section={section} />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
